// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.
import React from 'react';
import { Typography } from '@kintent/glide';
import styled from '@emotion/styled';
import { Link } from 'react-navi';

import { Flex } from '../../../../components/Flex';

const WrappedHeading = styled(Typography)`
  word-break: break-word;
`;

export function CertificationAuditFirm({ selectedCertification, selectedDocument }) {
  const selectedArtifact = selectedDocument ?? selectedCertification;
  if (selectedArtifact?.certificationDate) {
    return (
      selectedArtifact?.auditNameFirm && (
        <Flex
          gap="16px"
          direction="column"
        >
          <Typography
            as="p"
            level="9"
          >
            Name of Audit Firm
          </Typography>
          <WrappedHeading
            as={selectedArtifact?.auditFirmWebsite ? Link : 'p'}
            level="8"
            href={selectedArtifact?.auditFirmWebsite ?? null}
            target="_blank"
          >
            {selectedArtifact.auditNameFirm}
          </WrappedHeading>
        </Flex>
      )
    );
  }
  return null;
}
